import { render, staticRenderFns } from "./OverlayBack.vue?vue&type=template&id=3f05c279"
import script from "./OverlayBack.vue?vue&type=script&lang=js"
export * from "./OverlayBack.vue?vue&type=script&lang=js"
import style0 from "./OverlayBack.vue?vue&type=style&index=0&id=3f05c279&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports